import { defineComponent } from "vue";
import { mapState } from "pinia";

import { useConvertToPendingPal } from "../../store/useConvertToPendingPal";

import CommentInput from "../../../../../resources-vue/vue-custom-elements/CommentInput/CommentInput.vue";
import FormSection from "../../../../../resources-vue/vue-custom-elements/FormSection/FormSection.vue";

export default defineComponent({
    components: {
        FormSection,
        CommentInput
    },

    data(vm) {
        return {
            commentInputClass: { input: "w-35" } as { input: string; textarea?: string },
            myNotes: { text: "" },
            popoverContent:
                "These personal notes are not part of the patient record and can only be viewed by the user who enters them."
        };
    },

    computed: {
        ...mapState(useConvertToPendingPal, {
            patient: "patientDetails",
            application: "application"
        })
    },
    methods: {
        resultCareGoalsAppended(value: string) {
            this.patient.myNotes.note += value;
        },
        resultCareGoals(value: string) {
            this.patient.myNotes.note = value;
        }
    }
});
